import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, OnChanges, NO_ERRORS_SCHEMA } from '@angular/core';
import { MaintenanceService } from '../../../../../techopsv4/services/maintenanceService';
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatSelect, MatOption, MatSuffix } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { NgClass, DatePipe } from '@angular/common';

@Component({
    selector: 'app-add-edit-forecast-master',
    templateUrl: './add-edit-forecast-master.component.html',
    styleUrl: './add-edit-forecast-master.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatFormField, MatSelect, MatOption, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, NgClass, DatePipe],
    schemas: [NO_ERRORS_SCHEMA],
})
export class AddEditForecastMasterComponent implements OnChanges, OnInit {
  currentDate = this.toCentralTime(new Date());
  @Input() isEdit: boolean = false;
  @Input() forecastCycleArr: Array<any> = [];
  @Input() editData = null;
  forecastYearArr = [
    this.toCentralTime(new Date()).getFullYear(),
    this.toCentralTime(new Date()).getFullYear() + 1
  ];
  weeksArr = [4, 5, 6, 7];
  currentYear = this.toCentralTime(new Date()).getFullYear();
  endYearArr = [this.currentYear, this.currentYear + 1];
  endMonthArr = [
    { name: 'January', isDisabled: false, index: 0 },
    { name: 'February', isDisabled: false, index: 1 },
    { name: 'March', isDisabled: false, index: 2 },
    { name: 'April', isDisabled: false, index: 3 },
    { name: 'May', isDisabled: false, index: 4 },
    { name: 'June', isDisabled: false, index: 5 },
    { name: 'July', isDisabled: false, index: 6 },
    { name: 'August', isDisabled: false, index: 7 },
    { name: 'September', isDisabled: false, index: 8 },
    { name: 'October', isDisabled: false, index: 9 },
    { name: 'November', isDisabled: false, index: 10 },
    { name: 'December', isDisabled: false, index: 11 }
  ];
  short_months = {
    Jan: 'January',
    Feb: 'February',
    Mar: 'March',
    Apr: 'April',
    May: 'May',
    Jun: 'June',
    Jul: 'July',
    Aug: 'August',
    Sep: 'September',
    Oct: 'October',
    Nov: 'November',
    Dec: 'December'
  };
  userData: any = sessionStorage.getItem('config');
  isInValidData: boolean = false;
  email_min_date: Date;
  email_max_date: Date;
  Forecast_Year = null;
  Forecast_Cycle = null;
  weeks = 5;
  Start_Date = null;
  End_Date = null;
  Email_Start_Date = null;
  FC_Start_Month = null;
  FC_End_Month = null;
  Start_Month = null;
  Start_Year = null;
  C_Description = '';
  F_Description = '';
  notification_email = '';
  isPrevious = false;
  @Output() updateMasterTable = new EventEmitter();
  Admin_End_Date = null;
  admin_end_min_date: any;
  admin_end_max_date: Date;
  daysForAllWeeks = 'Monday'
  daysForLastWeek = 'Monday,Wednesday,Friday'
  Weeks_Between_Start_End_Date;
  Weeks_Between_End_AdminEnd_Date;
  constructor(
    private maintenanceService: MaintenanceService,
    private toaster: ToastrService,
  ) { }

  ngOnInit(): void {
    this.isInValidData = false;
    this.updateEndMonthArr();
    this.getWeeksBetweenStartEndDate();
    this.getWeeksBetweenEndAdminEndDate();
  }
  ngOnChanges() {
    if (this.editData) {
      this.Forecast_Year = this.editData.Forecast_Year;
      this.Forecast_Cycle = this.editData.Forecast_Cycle;
      // this.weeks = this.editData.weeks;
      //year for Start Date
      this.Start_Date = new Date(this.editData.Start_Date.split('-').map(Number));
      this.Start_Date.setHours(0, 0, 0, 0);
      this.End_Date = this.editData.End_date ? new Date(this.editData.End_date.split('-').map(Number)) : [null, null, null];
      this.End_Date.setHours(0, 0, 0, 0);
      this.Weeks_Between_Start_End_Date = this.getWeeksBetweenStartEndDate();
      //year for Admin End Date
      this.Admin_End_Date = this.editData.Admin_End_Date ? new Date(this.editData.Admin_End_Date.split('-').map(Number)) : [null, null, null];
      this.Admin_End_Date.setHours(0, 0, 0, 0);
      this.Weeks_Between_End_AdminEnd_Date = this.getWeeksBetweenEndAdminEndDate();
      //year for Start Date
      this.Email_Start_Date = this.editData.Email_Start_Date ? new Date(this.editData.Email_Start_Date.split('-').map(Number)) : [null, null, null];
      this.Email_Start_Date.setHours(0, 0, 0, 0);
      this.admin_end_min_date = this.Admin_End_Date;
      this.FC_Start_Month = this.editData.FC_Start_Month;
      this.FC_End_Month = this.editData.FC_End_Month;
      this.Start_Month = this.short_months[this.editData.FC_Start_Month.split(',')[1]];
      this.Start_Year = parseInt(this.editData.FC_Start_Month.split(',')[0]);
      this.C_Description = this.editData.C_Description;
      this.F_Description = this.editData.F_Description;
      this.isPrevious = this.editData.Previous.toLowerCase() == 'yes' ? true : false;
      this.setMinMaxAdminEndDate();
    }
  }

  dateChange() {
    // const end_date = new Date(this.Start_Date);
    // end_date.setDate(end_date.getDate() + this.weeks * 7 - 3);
    // this.End_Date = end_date;
    // this.Admin_End_Date = (this.Admin_End_Date != null && new Date(this.Admin_End_Date) < end_date) ? end_date : (this.Admin_End_Date == null ? end_date : this.Admin_End_Date);
    // if (this.Weeks_Between_Start_End_Date <5) {
    //   const email_date = new Date(this.Start_Date);
    //   this.Email_Start_Date = email_date;
    // }
    this.validate();
    // this.setValidMinMaxStartEndDate();
    this.getWeeksBetweenStartEndDate();
    this.setMinMaxAdminEndDate();
    this.getWeeksBetweenEndAdminEndDate();
    this.setEmailStartDate();
  }

  setMinMaxAdminEndDate() {
    const minDate = this.End_Date ? this.End_Date : null;
    if (!this.End_Date) {
      this.admin_end_min_date = null;
      this.Admin_End_Date = null;
      return;
    }
    if (this.End_Date > this.Admin_End_Date) {
      this.Admin_End_Date = this.End_Date;
    }
    this.admin_end_min_date = minDate;
  }

  adminEndDateChange() {
    this.validate();
    this.setMinMaxAdminEndDate();
    this.getWeeksBetweenEndAdminEndDate();
  }


  fieldValueChange() {
    this.validate();
  }
  dropdownChange(ev, item) {
    if (item == 'Start_Year') {
      let isDisableCheck: boolean = true;
      if (ev.value != this.currentYear) {
        isDisableCheck = false;
      }
      this.updateEndMonthArr(isDisableCheck);
    }
    if (item == 'Start_Year' || item == 'Start_Month') {
      this.updatePayloadData();
    }
    this.validate();
  }

  updatePayloadData() {
    if (this.Start_Month && this.Start_Year) {
      this.FC_Start_Month = this.Start_Year + ',' + this.Start_Month.substring(0, 3);
      this.FC_End_Month = this.Start_Year + 1 + ',' + 'Dec';
    }
  }

  forceMondayFilter = date => {
    if (date) {
      const day = date.getDay();
      return day == 1;
    }
  };

  forceFridayFilter = date => {
    if (date) {
      const day = date.getDay();
      return day == 5;
    }
  };

  adminEndDateFilter = (date: Date | null): boolean => {
    if (!this.End_Date) {
      // If End_Date is null, make nothing selectable
      return false;
    }
    if (date) {
      const day = date.getDay();
      const endDate = this.End_Date;
      // Allow only Fridays and dates greater than or equal to End_Date
      return day === 5 && date >= endDate;
    }
    return false;
  };

  updateEndMonthArr(isDisabledCheckRequired: boolean = true) {
    const forecastMonth = JSON.parse(sessionStorage.getItem('config')).currentMonthFull.toLowerCase();
    let isDisabled = isDisabledCheckRequired ? true : false;
    this.endMonthArr.forEach(val => {
      if (isDisabledCheckRequired && val.name.toLowerCase() == forecastMonth) {
        val.isDisabled = isDisabled;
        isDisabled = false;
      } else {
        val.isDisabled = isDisabled;
      }
      if (this.Start_Month && isDisabledCheckRequired) {
        if (val.name.toLowerCase() == this.Start_Month.toLowerCase() && val.isDisabled && !this.isEdit) {
          this.Start_Month = null;
        }
      }
    });
  }
  updateForecast() {
    const payload = {
      // weeks: this.weeks,
      FC_Start_Month: this.FC_Start_Month,
      FC_End_Month: this.FC_End_Month,
      Start_Date: this.Start_Date,
      Email_Start_Date: this.Email_Start_Date,
      End_Date: this.End_Date,
      C_Description: this.C_Description,
      F_Description: this.F_Description,
      Previous: this.editData.Previous,
      Admin_End_Date: this.Admin_End_Date,
      FC_For_Year: this.Start_Year,
      daysForAllWeeks: this.daysForAllWeeks,
      daysForLastWeek: this.daysForLastWeek
    }
    payload.Start_Date = this.formatDate(this.Start_Date);
    payload.End_Date = this.formatDate(this.End_Date);
    payload.Email_Start_Date = this.formatDate(this.Email_Start_Date);
    payload.Admin_End_Date = this.formatDate(this.Admin_End_Date);
    this.maintenanceService.updateForecastMaster(payload).subscribe(
      (res: Array<any>) => {
        if (res) {
          this.updateMasterTable.emit('Success');
          this.toaster.success('Successfully Updated.', '', {
            timeOut: 5000,
            positionClass: 'toast-top-center'
          });
        }
      },
      error => {
        console.error('Error updating forecast master:', error);
        this.toaster.error('Failed to update forecast master', '', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
      }
    );
  }
  onCreate() {
    if (this.isEdit) {
      this.updateForecast();
      return;
    }
    const payload = {
      Forecast_Cycle: this.Forecast_Cycle,
      Forecast_Year: this.Forecast_Year,
      // weeks: this.weeks,
      FC_Start_Month: this.FC_Start_Month,
      FC_End_Month: this.FC_End_Month,
      Start_Date: this.Start_Date,
      Email_Start_Date: this.Email_Start_Date,
      Admin_End_Date: this.Admin_End_Date,
      End_Date: this.End_Date,
      C_Description: this.C_Description,
      F_Description: this.F_Description,
      Previous: 'No',
      FC_For_Year: this.Forecast_Year,
      daysForAllWeeks: this.daysForAllWeeks,
      daysForLastWeek: this.daysForLastWeek,
      notification_email: this.notification_email
    }
    payload.Start_Date = this.formatDate(this.Start_Date);
    payload.End_Date = this.formatDate(this.End_Date);
    payload.Email_Start_Date = this.formatDate(this.Email_Start_Date);
    payload.Admin_End_Date = this.formatDate(this.Admin_End_Date);
    this.maintenanceService.addForecastCycle(payload).subscribe(
      (res: any) => {
        if (res) {

          this.updateMasterTable.emit('Success');
          if (res.adfPipelineresult === 'success') {
            this.toaster.success('New Cycle request sent. You will be notified via email once completed.', '', {
              timeOut: 5000,
              positionClass: 'toast-top-center'
            });
          }
          else {
            this.toaster.success('Error while adf pipeline execution', '', {
              timeOut: 5000,
              positionClass: 'toast-top-center'
            });

          }



        }
      },
      error => {
        console.error(error);
        this.toaster.error('Error While Adding Data', '', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
      }
    );
  }

  formatDate(date) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  validate() {
    let isValid: boolean = true;
    if (this.Forecast_Cycle == null) isValid = false;
    if (this.Forecast_Year == null) isValid = false;
    if (this.Email_Start_Date == null) isValid = false;
    if (this.Start_Date == null) isValid = false;
    if (this.End_Date == null) isValid = false;
    if (this.Admin_End_Date == null) isValid = false;
    if (this.FC_End_Month == null) isValid = false;
    if (this.FC_Start_Month == null) isValid = false;
    if (this.C_Description == null) isValid = false;
    if (this.F_Description == null) isValid = false;
    this.isInValidData = isValid;
  }
  setEmailStartDate() {
    //if start or end date is not selected, set to No Mapping
    if (!this.Start_Date || !this.End_Date) {
      this.Email_Start_Date = "No Mapping";
      return;
    }
    //if time between start and end date is less or equal to 5 weeks, set to Start Date
    if (this.Weeks_Between_Start_End_Date <= 5) {
      this.Email_Start_Date = this.Start_Date;
    }
    //if time between start and end date is more than 5 weeks, set to 5 weeks before End Date
    if (this.Weeks_Between_Start_End_Date > 5) {
      let endDate = this.toCentralTime(new Date(this.End_Date));
      endDate.setDate(endDate.getDate() - (this.weeks * 7) + 1); // 5 weeks before End Date
      endDate = this.getNextMonday(endDate);
      this.Email_Start_Date = endDate;
    }
  }

  // Helper function to get next Monday
  getNextMonday(date) {
  const day = date.getDay();
  if (day === 1) return date; // Already Monday
  const diff = (8 - day) % 7; // Days until next Monday
  date.setDate(date.getDate() + diff);
  return date;
}

  getWeeksBetweenStartEndDate() {
    if (this.Start_Date && this.End_Date) {
      const startDate = this.toCentralTime(new Date(this.Start_Date));
      const endDate = this.toCentralTime(new Date(this.End_Date));

      // Calculate the difference in milliseconds
      const diffInMs = endDate.getTime() - startDate.getTime();

      // Convert milliseconds to weeks
      const diffInWeeks = Math.ceil(diffInMs / (1000 * 60 * 60 * 24 * 7));

      // Update the weeksBetweenDates property
      this.Weeks_Between_Start_End_Date = diffInWeeks;
      if (this.Weeks_Between_Start_End_Date <= 0) {
        this.End_Date = null;
        this.Weeks_Between_Start_End_Date = null;
      }
    } else {
      this.Weeks_Between_Start_End_Date = null; // Clear if dates are not selected
    }
  }

  get formattedEmailStartDate(): string {
    if (this.Email_Start_Date instanceof Date) {
      return this.Email_Start_Date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      }); // Format the date as needed
    }
    return 'No Mapping';
  }

  getWeeksBetweenEndAdminEndDate() {
    if (this.End_Date && this.Admin_End_Date) {
      const endDate = this.toCentralTime(new Date(this.End_Date));
      const adminEndDate = this.toCentralTime(new Date(this.Admin_End_Date));

      // Calculate the difference in milliseconds
      const diffInMs = adminEndDate.getTime() - endDate.getTime();

      // Convert milliseconds to weeks
      const diffInWeeks = Math.ceil(diffInMs / (1000 * 60 * 60 * 24 * 7));

      // Update the weeksBetweenDates property
      this.Weeks_Between_End_AdminEnd_Date = diffInWeeks;
    } else {
      this.Weeks_Between_End_AdminEnd_Date = null; // Clear if dates are not selected
    }
  }

  getMinEndDate() {
    // If Start_Date is null, return the current date
    if (!this.Start_Date) {
      return null;
    }
    // Otherwise, return Start_Date
    return this.Start_Date;
  }

  toCentralTime(date: Date): Date {
    const centralTimeFormatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago', // Central Time Zone
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    });

    const parts = centralTimeFormatter.formatToParts(date);
    const year = parseInt(parts.find((p) => p.type === 'year')?.value || '0', 10);
    const month = parseInt(parts.find((p) => p.type === 'month')?.value || '0', 10) - 1; // Months are 0-indexed
    const day = parseInt(parts.find((p) => p.type === 'day')?.value || '0', 10);
    const hour = parseInt(parts.find((p) => p.type === 'hour')?.value || '0', 10);
    const minute = parseInt(parts.find((p) => p.type === 'minute')?.value || '0', 10);
    const second = parseInt(parts.find((p) => p.type === 'second')?.value || '0', 10);

    return new Date(year, month, day, hour, minute, second);
  }

  getFirstValidStartDate(): Date | null {
    const minDate = this.currentDate;

    // Start from the minimum date and find the first valid date
    let date = new Date(minDate);
    while (!this.forceMondayFilter(date)) {
      date.setDate(date.getDate() + 1); // Increment the date by 1 day
    }
    return date;
  }

  getFirstValidEndDate(): Date | null {
    const minDate = this.getMinEndDate() || this.currentDate;

    // Start from the minimum date and find the first valid date
    let date = new Date(minDate);
    while (!this.forceFridayFilter(date)) {
      date.setDate(date.getDate() + 1); // Increment the date by 1 day
    }
    return date;
  }

  getFirstValidAdminEndDate(): Date | null {
    const minDate = this.admin_end_min_date;
    while (!this.adminEndDateFilter(minDate)) {
      minDate.setDate(minDate.getDate() + 1); // Increment the date by 1 day
    }
    return minDate;
  }
}
